import React from 'react';

import { DamageLocation } from '@motorway/mw-highway-code';

import { clientSidePDR } from 'Utilities/helpers';
import type { PhotoType } from 'Utilities/profiling/@types';

import { useBreakpoint } from '../../../../components/misc/Breakpoints/Breakpoints';

import {
  DAMAGES_SIZES, getPresetImage, RESOLUTION,
} from './ConfirmDetails.helpers';
import { PhotoImage } from './PhotoImage';

import styles from './BlockWithImages.module.scss';

type ConditionImageProps = {
  damageMeta?: PhotoType['damageMeta'];
  isPhotosLoading?: boolean;
  label?: string;
  name?: string;
  presets?: PhotoType['presets'];
  url?: string;
};

export const ConditionImage = ({
  damageMeta, isPhotosLoading = false, label, name, presets, url,
}: ConditionImageProps) => {
  const breakpoints = useBreakpoint();
  const tabletBreakpoint = breakpoints?.maxWidth?.breakpointMobile;
  const deviceResolution = tabletBreakpoint ? RESOLUTION.MOBILE : RESOLUTION.DESKTOP;
  const presetImage = getPresetImage(presets, deviceResolution.toLowerCase());

  return (
    <div className={styles.imageSection}>
      <PhotoImage
        hasEmptyState={!isPhotosLoading}
        image={`${presetImage || url}&dpr=${clientSidePDR()}`}
        imageClassName={styles.image}
      />
      <div className={styles.damageInfo}>
        <div>
          <div className={styles.title}>
            {label}
          </div>
          {damageMeta?.size && (<div>{DAMAGES_SIZES[damageMeta.size as keyof typeof DAMAGES_SIZES]}</div>)}
        </div>
        {damageMeta && (
          <DamageLocation
            damageMeta={damageMeta}
            data-thc-damage-location={damageMeta?.side}
            kind={name}
          />
        )}
      </div>
    </div>
  );
};
